import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const gcard = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return gcard.get("greeting-cards/settings" + qstr);
  },
  update(inputs) {
    return gcard.put("/greeting-cards/settings", inputs);
  },
};
